import n from "./en-US.json.js";
const s = { ...n }, t = (o) => o.then(({ default: _ }) => _), i = { da_DK: () => t(import("./da-DK.json.js")) }, r = { de_DE: () => t(import("./de-DE.json.js")) }, c = { es_ES: () => t(import("./es-ES.json.js")) }, p = { fi_FI: () => t(import("./fi-FI.json.js")) }, e = { fr_FR: () => t(import("./fr-FR.json.js")) }, m = { it_IT: () => t(import("./it-IT.json.js")) }, l = { nl_NL: () => t(import("./nl-NL.json.js")) }, S = { no_NO: () => t(import("./no-NO.json.js")) }, a = { pt_BR: () => t(import("./pt-BR.json.js")) }, E = { sv_SE: () => t(import("./sv-SE.json.js")) }, f = { en_US: s }, N = {
  ...i,
  ...r,
  ...f,
  ...c,
  ...p,
  ...e,
  ...m,
  ...l,
  ...S,
  ...a,
  ...E
};
export {
  N as all_locales,
  i as da_DK,
  r as de_DE,
  f as en_US,
  c as es_ES,
  p as fi_FI,
  e as fr_FR,
  m as it_IT,
  l as nl_NL,
  S as no_NO,
  a as pt_BR,
  E as sv_SE
};
